import React from "react";
import "./range.css";

interface HorizontalSliderProps {
    value?: number;
    onValueChange?: (value: number) => void;
    width?: number;
    min?: number;
    max?: number;
    step?: number;
}

export const HorizontalSlider = ({
    value = 0,
    onValueChange,
    width = 80,
    min = 0,
    max = 99,
    step = 1,
}: HorizontalSliderProps) => {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = Number(event.target.value);
        if (onValueChange) {
            onValueChange(newValue);
        }
    };

    const increment = () => {
        if (onValueChange) {
            onValueChange(Math.min((value ?? 0) + step, max));
        }
    };

    const decrement = () => {
        if (onValueChange) {
            onValueChange(Math.max((value ?? 0) - step, min));
        }
    };

    return (
        <div className="slider-wrapper">
            <button type="button" onClick={decrement} className="slider-button">
                –
            </button>
            <input
                type="range"
                min={min}
                max={max}
                value={value}
                step={step}
                onChange={handleChange}
                style={{ width }}
            />
            <button type="button" onClick={increment} className="slider-button">
                +
            </button>
        </div>
    );
};
